
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';


// import created components  :
import Background from '../../../components/background/Background.jsx'
import WallyBanner from '../../../components/wallybanner/WallyBanner.jsx'
import ManagerMenu from '../../../components/managermenu/ManagerMenu.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";


// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//MUI :
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CircularProgress from '@mui/material/CircularProgress';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import HearingIcon from '@mui/icons-material/Hearing';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import LayersIcon from '@mui/icons-material/Layers';

import CheckIcon from '@mui/icons-material/Check';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';


//Utils
import { checkLogin } from '../../../utils/check-login.js'
import setNumResa from '../../../utils/set_num_resa.js'; //params : resaInfos
import convertHoraire from '../../../utils/convert_horaire.js';
import sortElevesCreneaux from '../../../utils/sort-eleves-creneaux.js';


//data
import { listNiveau, listFidelite } from '../../../config/niveau-fidelite-config.js'

//dialog

function SimpleDialog(props) {
    const { onClose, open, listDeMails } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog onClose={handleClose} open={open} >
            <div className="manager-clients-dialog">

                <DialogTitle>Mailling list</DialogTitle>

                <p>{listDeMails}</p>
            </div>

        </Dialog>
    );
}

//// --- Start of Accordeons config 

const iconesList = [<AutoStoriesIcon />, <LayersIcon />, <Diversity3Icon />, <CropSquareIcon />, <RemoveRedEyeIcon />, <SignalCellularAltIcon />, <HearingIcon />]

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

//// --- end of accordion config



function ManagerClients() { // full page as component imported in router

    const dispatch = useDispatch();
    const navigate = useNavigate();

    let [clientsInfos, setClientsInfos] = useState([]);
    let [filteredClients, setFilteredClients] = useState([]);
    let [searchFilter, setSearchFilter] = useState("");
    let [showInfos, setShowInfos] = useState([]);
    let [listSorter, setListSorter] = useState({ type: "alpha", sens: "asc" });

    const [open, setOpen] = useState(false);
    const [mailingList, setMailingList] = useState("");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
    };

    let isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
    dayjs.extend(isSameOrAfter)
    let isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
    dayjs.extend(isSameOrBefore)

    //// -- at first render :
    useEffect(() => {


        if (checkLogin() === false) {

            navigate(`/manager/login?dest=manager/clients`)
        }

        async function initClients() { //we add this inner function to manage asynchrone
            let infosClients = await getClientAllInfos();
            setClientsInfos(infosClients);

            if (searchFilter.length === 0 && filteredClients.length === 0) { setFilteredClients(infosClients); }
        } //end of async function


        initClients(); //call the inner asnchrone function


    }, [])
    //// -- 

    //// -- at clients loaded from db :
    /*  useEffect(() => {
 
         console.log(clientsInfos.length);
 
     }, [clientsInfos]) */
    //// -- 


    async function getClientAllInfos() { //jour : date as string

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/client/infos/all`,
            });
            //console.log(response);
            const clients = response.data.data;
            return clients;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    function filterClients(word) {
        console.log(word);
        setFilteredClients(clientsInfos.filter((client) =>
            (client.prenom.toLowerCase() === word.toLowerCase() || client.nom.toLowerCase() === word.toLowerCase() || client.tel === word || client.email === word.toLowerCase())
        ));

    }

    function sortClients(list) {

        if (listSorter.type === "alpha") {
            if (listSorter.sens == "asc") {
                return list.toSorted((c1, c2) => c1.nom.toLowerCase() > c2.nom.toLowerCase());
            }
            else {
                return list.toSorted((c1, c2) => c1.nom.toLowerCase() < c2.nom.toLowerCase());
            }

        }
        else { //sort by date creation
            if (listSorter.sens == "asc") {
                return list.toSorted((c1, c2) => dayjs(c1.created).isAfter(dayjs(c2.created)));
            }
            else {
                return list.toSorted((c1, c2) => dayjs(c1.created).isBefore(dayjs(c2.created)));
            }
        }

    }

    function handleSort(type) {

        if (type === listSorter.type) { //// same type
            if (listSorter.sens === "asc") {
                setListSorter({ type: listSorter.type, sens: "desc" })
            }
            else {
                setListSorter({ type: listSorter.type, sens: "asc" })
            }

        }
        else {
            setListSorter({ type: type, sens: "asc" })
        }
    }

    function dateSorter(resas) {
        return resas.toSorted((r1, r2) => dayjs(r1.created).isAfter(dayjs(r2.created)));
    }

    function getBtClass(type) {
        let laClass = "manager-clients-top-searchbar-btsort"

        laClass += type === listSorter.type ? " selected-sorter " : " "

        return laClass;

    }

    function getNoMatchInfos(nb_modifs) {
        let info = "No match, attente : ";
        if (nb_modifs % 2 === 0) {
            info += "Wally";
        }
        else {
            info += "client";
        }
        return info;

    }

    const today = dayjs(); // set the date of the current day

    function infosShower(id) {
        //let temp = showInfos;
        let temp = [];
        let coche = false;
        if (showInfos[id]) { coche = !showInfos[id]; }
        else { coche = true; }
        temp[id] = coche;
        setShowInfos(temp);

    }

    function getNiveau(id) {
        return listNiveau.find(niveau => niveau.id === id).intitule
    }
    function getFidelite(id) {
        return listFidelite.find(fid => fid.id === id).intitule
    }

    const [expanded, setExpanded] = useState(0);
    const [panelOpen, setPanelOpen] = useState(false);

    const handleChange = (panel) => (event, newExpanded) => { //manage the change of accordion
        setExpanded(newExpanded ? panel : false);
        setPanelOpen(false);
    };



    function checkFinished(resa) {
        if (resa.CreneauEleves.length === 0) { return false; }
        let passee = false;
        let dates = sortElevesCreneaux(resa.CreneauEleves).dateList;
        let lastDate = dates[dates.length - 1];
        passee = dayjs().isAfter(dayjs(lastDate), "day")
        return passee;

    }

    function checkStarted(resa) {
        if (resa.CreneauEleves.length === 0) { return false; }
        let started = false;
        let dates = sortElevesCreneaux(resa.CreneauEleves).dateList;
        let lastDate = dates[dates.length - 1];
        let firstDate = dates[0];
        started = dayjs().isSameOrBefore(dayjs(lastDate), "day") && dayjs().isSameOrAfter(dayjs(firstDate), "day")
        return started;

    }

    function displayEmailsList() {
        let list = "";
        clientsInfos && clientsInfos.forEach((client) => {
            list += client.email + ";"
        })

        //alert(list.slice(0, -1));
        setMailingList(list.slice(0, -1));
        handleClickOpen();
    }


    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />
                    <ManagerMenu current="clients" />

                    <div className="manager-clients">
                        <h1>Clients Wally Glisse</h1>
                        <span className="manager-clients-bt-mail" onClick={_ => displayEmailsList()}><MailOutlineIcon /></span>

                        <div className="manager-clients-top">
                            <div className="manager-clients-top-searchbar">
                                <div>
                                    <TextField
                                        className="manager-clients-top-searchbar-input"
                                        value={searchFilter}
                                        onChange={e => setSearchFilter(e.target.value)}
                                    />

                                    <Button
                                        className="manager-clients-top-searchbar-btsearch"
                                        variant="contained"
                                        disabled={searchFilter.length === 0}
                                        onClick={_ => filterClients(searchFilter)}>
                                        Chercher
                                </Button>
                                    <Button
                                        className="manager-clients-top-searchbar-bttous"
                                        variant="contained"
                                        onClick={_ => { setFilteredClients(clientsInfos); setSearchFilter(""); }}>
                                        tous
                                </Button>
                                </div>

                                <div>
                                    <p>Tri par :</p>
                                    <Button
                                        className={getBtClass("alpha")}
                                        variant="contained"
                                        onClick={_ => handleSort("alpha")}>
                                        Alphabet
                                    {listSorter.type === "alpha" ? listSorter.sens === "asc" ? <ArrowDropUpIcon /> : <ArrowDropDownIcon /> : null}
                                    </Button>
                                    <Button
                                        className={getBtClass("date")}
                                        variant="contained"
                                        onClick={_ => handleSort("date")}>
                                        Date créa.
                                    {listSorter.type === "date" ? listSorter.sens === "asc" ? <ArrowDropUpIcon /> : <ArrowDropDownIcon /> : null}
                                    </Button>
                                </div>
                            </div>

                        </div>

                        <div className="manager-clients-bottom">
                            {
                                filteredClients && filteredClients.length === 0 && searchFilter.length > 0 ?
                                    <Alert severity="info">Aucun client ne correspond à ce critère de recherche.</Alert>
                                    : null
                            }


                            {clientsInfos && clientsInfos.length > 0 ?
                                <div className="manager-clients-bottom-list">
                                    {sortClients(filteredClients).map((client) =>

                                        <section key={client.id_client}>
                                            <div className="manager-clients-bottom-list-item" onClick={_ => infosShower(client.id_client)}>
                                                <div>
                                                    <p>{client.nom}</p>
                                                    <p>{client.prenom}</p>
                                                </div>
                                                <div>
                                                    <p>{client.Resas.length} résa</p>
                                                    <p>{client.Eleves.length} élèves</p>
                                                    <p>{client.tel}</p>
                                                </div>
                                                <div>
                                                    <p>{client.email}</p>
                                                    <p>{dayjs(client.created).format("DD/MM/YYYY")}</p>
                                                </div>
                                            </div>
                                            {showInfos[client.id_client] === true ?
                                                <div className="manager-clients-bottom-list-infos">
                                                    <div className="manager-clients-bottom-list-infos-eleves">
                                                        <h3>Elèves</h3>
                                                        <div>
                                                            {
                                                                client.Eleves.map((eleve) =>
                                                                    <p key={eleve.id_eleve}><i>{eleve.prenom}</i> <span>-</span> age : {eleve.age} <span>-</span> niveau : {getNiveau(eleve.niveau_id)} <span>-</span> {getFidelite(eleve.fidelite_id)}</p>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="manager-clients-bottom-list-infos-resa">
                                                        <h3>Réservations</h3>
                                                        <div>

                                                            {dateSorter(client.Resas).map((resa) => ( // for every resaétences listed in JSON file
                                                                <Accordion expanded={expanded === resa.id_resa} onChange={handleChange(resa.id_resa)} key={resa.id_resa}>
                                                                    <AccordionSummary >
                                                                        <div className="manager-clients-bottom-accordeon-header">
                                                                            <h3>{setNumResa(resa)} {checkFinished(resa) && <CheckIcon />} {checkStarted(resa) && <MoreHorizIcon />}</h3>
                                                                            <div>
                                                                                <p className={resa.match === true ? "info-match" : "info-nomatch"}>{resa.match === true ? "Match" : getNoMatchInfos(resa.nb_modifs)}</p>
                                                                                <p className="info-match">{resa.solde === 0 ? "Payé en ligne" : ""}</p>
                                                                            </div>

                                                                        </div>

                                                                    </AccordionSummary>
                                                                    <AccordionDetails>

                                                                        <div className="manager-clients-bottom-accordeon-intro">
                                                                            <p>Date de création : {dayjs(resa.created).format("DD/MM/YYYY")}</p>
                                                                            <p>Nombre de modifs : {resa.nb_modifs}</p>
                                                                            <h4>Tarif : {Math.round((100 - resa.coupon) / 100 * resa.total)},00€ {resa.coupon > 0 ? ` (Réduction de ${resa.coupon}%)` : ""}</h4>
                                                                        </div>
                                                                        <div className="manager-clients-bottom-accordeon-formules">
                                                                            <h3>Sessions :</h3>
                                                                            <div className="match-jours-manager">
                                                                                {sortElevesCreneaux(resa.CreneauEleves) && sortElevesCreneaux(resa.CreneauEleves).dateList.map((date) => (
                                                                                    <div className="match-jours-manager-bloc" key={date}>
                                                                                        <h3 className="match-jours-manager-bloc-date">{dayjs(date).format("DD/MM/YYYY")}</h3>
                                                                                        {sortElevesCreneaux(resa.CreneauEleves).creneaux.filter((c) => c.date === date).map((creneau) => (
                                                                                            <div className="match-jours-manager-bloc-creneau" key={creneau.id}>
                                                                                                <p className="match-jours-manager-bloc-creneau-horaire">{convertHoraire(creneau.horaire, "horaire")}</p>
                                                                                                <ul className="match-jours-manager-bloc-creneau-eleves">
                                                                                                    {creneau.eleves.map((e, index) => (
                                                                                                        <li key={index}>{e.prenom}</li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>


                                                                    </AccordionDetails>
                                                                </Accordion>

                                                            ))
                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                                : null}
                                        </section>

                                    )}
                                </div>
                                :
                                <CircularProgress />
                            }

                        </div>





                    </div>



                </div>

                <SimpleDialog
                    open={open}
                    onClose={handleClose}
                    listDeMails={mailingList}
                />

            </main>
        </div >
    );
}

export default ManagerClients;